export default {
    'name': 'rerexam',
    'label': 'legal.tabs.Rerexam',
    'getComponent': () => import('./rerexam.vue'),
    'tabIndex': 3,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/legal/rerexam',
};
